// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1AQpX","footer":"Form_footer__v3amV"};